import StatTableType from '../../components/StatTable/StatTableType';

export default function getSearchItemUri(ids) {
    const { area, suite, product, category, type } = ids;
    const uriSegments = [];
    if (area) {
        uriSegments.push(`/areas/${area}`);
        if (suite) {
            uriSegments.push(`/suites/${suite}`);
            if (product) {
                if (type === StatTableType.SERVICES) {
                    uriSegments.push(`/products/${product}`);
                } else {
                    uriSegments.push(`/products/${product}/customers`);
                }
                if (category) {
                    uriSegments.push(`/categories/${category}/customers`);
                }
            }
        }
    }

    return uriSegments.join('');
}
